import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconManagementView(props: SvgIconProps) {
  return (
    <SVGIcon xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" {...props}>
      <g clipPath="url(#clip0_880_19119)">
        <rect x="0.5" y="1.5" width="11" height="3" rx="0.5" stroke="currentcolor" />
        <rect x="0.5" y="1.5" width="3" height="3" rx="0.5" stroke="currentcolor" />
        <rect x="0.5" y="7.5" width="11" height="3" rx="0.5" stroke="currentcolor" />
        <rect x="0.5" y="7.5" width="3" height="3" rx="0.5" fill="currentcolor" stroke="currentcolor" />
      </g>
      <defs>
        <clipPath id="clip0_880_19119">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </SVGIcon>
  );
}
